export default {
  common: {
    appName: 'Honey Badger Entertainment',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    submit: 'Envoyer',
    save: 'Enregistrer',
    usernameRequired: 'Veuillez saisir votre nom d\'utilisateur !',
    passwordRequired: 'Veuillez saisir votre mot de passe !',
    viewMore: 'Voir plus',
    refreshSuccess: 'Actualisé',
    noMore: 'Plus rien à afficher',
    emptyData: 'Aucune donnée',
  },
  footer: { home: 'Accueil', lottery: 'Loterie', game: 'Réservation', video: 'Vidéo', mine: 'Profil' },
  lang: { title: 'Langue / Language', current: 'Langue actuelle' },
  home: {
    recommendedTasks: 'Tâches recommandées',
    popularRanking: 'Classement de popularité',
    hotRecommend: 'Sélections populaires',
    playCount: 'Vues : {count}',
    noticeLoading: 'Chargement...',
  },
  game: {
    hallTitle: 'Salle de réservation',
    categoryAll: 'Tout',
  },
  choose: {
    title: 'Compagnes',
    tabCities: 'Annuaire des villes',
    tabProcess: 'Processus et tarifs',
    privacyNotice: 'La plateforme la plus authentique de compagnes, escortes d\'affaires et rencontres locales du net. Afin de protéger la vie privée de chaque utilisateur, l\'accès est réservé aux clients parrainés par nos réceptionnistes ou un membre senior vérifié.',
    resourcesQ: 'Quelles options sont disponibles ?',
    resourcesA: 'Influenceuses, mannequins, hôtesses de l\'air, jeunes mannequins et étudiantes — si vous pouvez l\'imaginer, nous pouvons l\'organiser.',
    scopeQ: 'Zone de service ?',
    scopeA: 'Rencontres gratuites en ville, déplacement en tout point du pays. Présent dans toutes les grandes villes ; les villes plus modestes s\'organisent via nos réceptionnistes.',
    book: 'Réservation',
    contactConcierge: 'Veuillez contacter un conseiller ou un réceptionniste',
    cityNames: {
      beijing: 'Pékin',
      shanghai: 'Shanghai',
      guangzhou: 'Guangzhou',
      shenzhen: 'Shenzhen',
      nanjing: 'Nankin',
      changsha: 'Changsha',
      chongqing: 'Chongqing',
      xian: 'Xi\'an',
    },
  },
  lottery: {
    gameRecord: 'Historique des tâches',
    orderList: 'Fiche de tâche',
    orderItemDetail: '1 mise X {money} = {money}',
    clearOrder: 'Vider la fiche',
    confirmSubmit: 'Confirmer et envoyer',
    availableBalance: 'Solde disponible',
    yuan: 'yuan',
    currentPick: 'Sélection actuelle : ',
    amountPerBet: 'Montant par mise : ',
    amountPlaceholder: 'Saisissez le montant',
    amountInvalid: 'Montant invalide !',
    fillAmount: 'Veuillez saisir un montant !',
    selectNumberFirst: 'Veuillez sélectionner des numéros !',
    insufficientBalance: 'Solde insuffisant, veuillez contacter le service client pour recharger !',
    notSelected: 'Non sélectionné',
    contactAdminForTask: 'Veuillez contacter l\'administrateur pour débloquer cette tâche !',
    drawSuccess: 'Tirage effectué, tirage n° : {expect}',
    periodNumber: 'Tirage n°',
    betUnit: 'pari(s)',
    totalAmountLabel: 'Montant total : ',
    totalCountLabel: 'Nombre total de paris : ',
    drawResult: 'Numéros tirés',
    big: 'Grand',
    small: 'Petit',
    single: 'Impair',
    doubleNum: 'Pair',
    rules: {
      title: 'Comment jouer',
      tipTitle: 'Comment parier',
      tipDetail: 'Choisissez vos numéros parmi les sommes disponibles pour placer une mise.',
      winTitle: 'Conditions de gain',
      winDetail: 'Une somme de 11~18 sur les trois numéros tirés vaut Grand ; une somme de 3~10 vaut Petit.',
      exampleTitle: 'Exemple de mise',
      exampleDetail: 'Mise : Petit. Numéros tirés : 123 — résultat : Petit.',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'Recharge', withdraw: 'Retrait', game: 'Pari' },
    },
    withdraw: {
      amountLabel: 'Montant du retrait (yuan)',
      all: 'Tout',
      limitRule1: '1. Limite par transaction : minimum {min}, maximum {max}',
      limitRule2: '2. Nombre de retraits : jusqu\'à {num} retraits par jour',
      limitRule3: '3. Délai de réception : généralement 5 minutes environ, au plus rapide 2 minutes',
      limitTitle: 'Détails des limites',
      balanceLabel: 'Solde : ',
      submit: 'Retirer maintenant',
      amountInvalid: 'Veuillez saisir un montant valide',
    },
    bindCard: {
      formLabel: 'Veuillez saisir les informations de votre carte de versement',
      bankidLabel: 'Numéro de carte',
      bankidPlaceholder: 'Saisissez le vrai numéro de carte',
      bankLabel: 'Nom de la banque',
      bankPlaceholder: 'Sélectionnez une banque',
      notice: 'Cher client, afin de sécuriser vos fonds, veuillez renseigner votre vrai nom et définir un mot de passe de retrait. Si le nom ne correspond pas au titulaire du compte, le retrait sera impossible.',
      submit: 'Confirmer la liaison',
      bankidRequired: 'Veuillez saisir le numéro de carte !',
      bankRequired: 'Veuillez sélectionner une banque !',
    },
    setbank: {
      title: 'Carte de versement',
      addCard: 'Ajouter une carte de versement',
      tips: 'Remarque : veuillez lier une grande banque commerciale. Contactez le service client en ligne si vous devez la modifier.',
      setNameFirst: 'Veuillez définir votre nom avant de lier une carte bancaire !',
      setPayPasswordFirst: 'Veuillez définir un mot de passe de retrait avant de lier une carte bancaire !',
    },
    setPayPassword: {
      firstPrompt: 'Saisissez le mot de passe de retrait',
      secondPrompt: 'Saisissez à nouveau le mot de passe de retrait',
      incomplete: 'Veuillez remplir complètement',
      mismatch: 'Les deux mots de passe ne correspondent pas !',
    },
    setLoginPassword: {
      oldPassword: 'Ancien mot de passe',
      oldPasswordPlaceholder: 'Saisissez votre ancien mot de passe',
      newPassword: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Saisissez votre nouveau mot de passe',
      confirmPasswordPlaceholder: 'Saisissez à nouveau votre nouveau mot de passe',
      incomplete: 'Veuillez remplir complètement !',
      mismatch: 'Les deux mots de passe ne correspondent pas',
    },
    setname: {
      nameLabel: 'Nom',
      namePlaceholder: 'Saisissez votre vrai nom',
      notice: 'Pour la sécurité de votre compte, le vrai nom doit correspondre au nom de la carte bancaire liée',
      alreadySet: 'Veuillez ne pas le définir plusieurs fois !',
      nameRequired: 'Veuillez saisir votre nom !',
    },
    setsex: {
      male: 'Homme',
      female: 'Femme',
    },
    infomation: {
      avatar: 'Photo de profil',
      chooseAvatar: 'Choisir une photo de profil',
      realName: 'Vrai nom',
      notSet: 'Non défini',
      gender: 'Sexe',
      unknown: 'Inconnu',
      bindInfo: 'Informations de liaison',
      bound: 'Lié',
      none: 'Aucun',
    },
    index: {
      recharge: 'Recharger',
      withdraw: 'Retirer',
      myWallet: 'Mon portefeuille',
      details: 'Détails',
      balanceLabel: 'Solde : ',
      personalReport: 'Rapport personnel',
      accountDetail: 'Détail du compte',
      profileCenter: 'Espace personnel',
      notice: 'Annonces',
      customerService: 'Service client',
      completeTaskFirst: "Veuillez d'abord terminer l'inscription",
      contactServiceToRecharge: 'Veuillez contacter le service client pour recharger',
      setPayoutCardFirst: "Veuillez d'abord configurer votre carte de retrait",
      featureDisabled: "Cette fonctionnalité n'est pas encore disponible",
      accountOffline: 'Compte hors ligne',
      loginRegister: 'Connexion / Inscription',
      loginHint: 'Connectez-vous pour voir',
    },
    setting: {
      basicInfo: 'Informations de base',
      loginPassword: 'Mot de passe de connexion',
      payPassword: 'Mot de passe de paiement',
      payPasswordAlreadySet: 'Le mot de passe de paiement est déjà défini !',
      signOut: 'Se déconnecter',
    },
    gameRecord: {
      betAmount: 'Montant misé : {money}',
      betTime: 'Heure du pari : {time}',
      settleTime: 'Heure du règlement : {time}',
    },
    withdrawRecord: {
      amount: 'Montant du retrait : {money}',
      desc: 'Note de retrait : {desc}',
      submitTime: "Heure de la demande : {time}",
      reviewTime: "Heure de l'examen : {time}",
    },
    report: {
      profitLabel: 'Gain/Perte',
      formulaTip: 'Gain/Perte = gains - mises + recharges - retraits',
      playAmount: 'Montant misé',
      rechargeAmount: 'Montant rechargé',
      withdrawAmount: 'Montant retiré',
      winAmount: 'Montant gagné',
    },
    service: {
      contact: 'Nous contacter',
      slogan: "N'hésitez pas à nous contacter pour toute question",
    },
  },
  video: {
    hallTitle: 'Cinéma vidéo',
    hotRecommend: 'Sélections populaires',
    playCount: 'Vues : {count}',
    playCountSuffix: '{count} vues',
    rechargeToWatch: 'Veuillez recharger avant de regarder les vidéos !',
  },
  recharge: {
    title: 'Recharge',
    chooseCoin: 'Choisir la devise',
    address: 'Adresse de dépôt',
    copy: 'Copier l\'adresse',
    copied: 'Copié',
    amount: 'Montant du dépôt',
    uploadShot: 'Téléverser la capture du virement',
    submit: 'Envoyer la demande de dépôt',
    pending: 'En attente',
    done: 'Crédité',
    rejected: 'Rejeté',
  },
  payMethod: {
    title: 'Choisir le moyen de réception',
    bankCard: 'Carte bancaire',
    wallet: 'Portefeuille crypto',
    unbind: 'Délier',
    bindNew: 'Lier une nouvelle adresse',
    confirmUnbind: 'Confirmer le déliement de ce moyen de réception ?',
    payPassword: 'Mot de passe de retrait',
    wrongPassword: 'Mot de passe de retrait incorrect',
    chooseFirst: 'Veuillez d\'abord choisir un moyen de réception',
  },
  router: {
    Index: { title: 'Accueil' },
    Home: { title: 'Accueil' },
    Choose: { title: 'Compagnes' },
    List: { title: 'Liste des compagnes' },
    Profile: { title: 'Profil de compagne' },
    Mine: { title: 'Profil' },
    Video: { title: 'Vidéo' },
    Game: { title: 'Jeux' },
    Login: { title: 'Connexion' },
    Register: { title: 'Inscription' },
    ServiceOnline: { title: 'Service client' },
    ServicePage: { title: 'Service client' },
    Setting: { title: 'Paramètres' },
    Infomation: { title: 'Informations de base' },
    Setname: { title: 'Modifier le nom réel' },
    Setsex: { title: 'Modifier le sexe' },
    SetPayPassword: { title: 'Mot de passe de paiement' },
    SetLoginPassword: { title: 'Mot de passe de connexion' },
    Lottery: { title: 'Loterie' },
    Notice: { title: 'Annonces' },
    PlayVideo: { title: 'Lecture vidéo' },
    Setbank: { title: 'Ajouter une carte de retrait' },
    BindCard: { title: 'Ajouter une carte de retrait' },
    Withdraw: { title: 'Retrait' },
    Recharge: { title: 'Recharge' },
    Personalreport: { title: 'Rapport personnel' },
    WithdrawRecord: { title: 'Historique de retrait' },
    AccountDetail: { title: 'Détails du compte' },
    GameRecord: { title: 'Historique de jeu' },
  },
  captcha: {
    placeholder: 'Captcha image',
    refresh: 'Toucher pour actualiser',
    error: 'Captcha incorrect',
    required: 'Veuillez saisir le captcha',
  },
  login: {
    title: 'Connexion',
    usernamePlaceholder: 'Veuillez saisir votre nom d\'utilisateur',
    passwordPlaceholder: 'Veuillez saisir votre mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    noAccountRegister: 'Pas de compte ? Inscrivez-vous maintenant',
    submit: 'Connexion',
  },
  register: {
    title: 'Inscription',
    usernamePlaceholder: 'Veuillez saisir un nom d\'utilisateur (6-12 lettres ou chiffres)',
    passwordPlaceholder: 'Veuillez saisir un mot de passe de connexion (6-12 lettres ou chiffres)',
    codePlaceholder: 'Veuillez saisir le code d\'invitation',
    protocol: 'J\'ai pris connaissance et j\'accepte les clauses de l\'"Accord d\'ouverture de compte"',
    submit: 'Inscription',
    codeRequired: 'Veuillez saisir le code d\'invitation !',
    agreementRequired: 'Veuillez cocher la case de l\'accord d\'ouverture de compte ci-dessous !',
  },
}
